import React, { useEffect } from 'react';
import logo from 'assets/images/login/logo.svg';
import img from 'assets/images/login/img.png';
import laptop from 'assets/images/login/laptop.svg';
import appStore from 'assets/images/login/app-store.svg';
import mobileLogo from 'assets/images/login/mobile-logo.svg';
import languageIcon from 'assets/images/icons/language-icon.svg';
import play from 'assets/images/login/play.svg';
import { useTranslation } from 'react-i18next';

import styles from './styles.scss';
import { setPopUp } from 'actions/environment';
import { Form } from './Form';
import { gaEvent, trackGA } from 'services/ga';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { useDispatch } from 'react-redux';
import LanguageModal from 'components/Language/LanguageModal';

const year = new Date().getFullYear();

const Login = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const dispatch = useDispatch();

  const handleOpenLanguageModal = () =>
    dispatch(
      setPopUp(<LanguageModal />, {
        closeStyleName: 'Default',
        contentStyleName: 'Default',
        closeIcon: 'default',
        lockScroll: false,
      })
    );

  useEffect(() => {
    trackGA(
      gaEvent.pageShow({
        screenName: location.pathname,
      })
    );

    const params = new URLSearchParams(location.search);
    const refLink = params.get('ref');
    if (refLink) {
      localStorage.setItem('ref', refLink);
    }
  }, []);

  const handleLinkClick = (store) => {
    trackGA(gaEvent.downloadAppClick({ eventContent: store }));
  };

  return (
    <div className={styles.Wrapper}>
      <div className={styles.Container}>
        <section className={styles.LeftSide}>
          <div className={styles.LeftSideTitle}>
            <img src={logo} alt="nedvex" />
          </div>
          <div className={styles.LeftSideDescription}>
            <div>{t('containers.logIn.description.1')}</div>
            <div>{t('containers.logIn.description.2')}</div>
          </div>
          <div className={styles.LeftSideLaptop}>
            <img src={img} alt="" />
            <img className={styles.LeftSideLaptopImg} src={laptop} alt="" />
          </div>
          <div className={styles.LeftSideStores}>
            <div>
              <a
                target="__blank"
                href="https://apps.apple.com/ru/app/nedvex/id1079767992"
                rel="noopener noreferrer"
                onClick={() => handleLinkClick('app_store')}
              >
                <img src={appStore} alt="app store" />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=ru.andrroider.apps.nedvex&hl=ru&gl=US"
                rel="noopener noreferrer"
                target="_blank"
                onClick={() => handleLinkClick('google_play')}
              >
                <img src={play} alt="google play" />
              </a>
            </div>
          </div>
        </section>
        <section className={styles.RightSide}>
          <button className={styles.LanguageButton} onClick={handleOpenLanguageModal}>
            <img className={styles.LanguageIcon} src={languageIcon} />
          </button>
          <img className={styles.MobileLogo} src={mobileLogo} />
          <Form />
          <div className={styles.RightSideFooter}>
            <div>
              <span className={styles.RightSideFooterLinks}>
                <a
                  target="__blank"
                  href="https://app.nedvex.ru/policy"
                  onClick={() =>
                    trackGA(
                      gaEvent.loginButtonsClick({
                        eventLabel: 'politika_konfidencialnosti',
                      })
                    )
                  }
                >
                  {t('containers.logIn.footer.privacy')}
                </a>
              </span>
              <span className={styles.RightSideFooterLinks}>
                <a target="__blank" href="https://app.nedvex.ru/eula">
                  {t('containers.logIn.footer.eula')}
                </a>
              </span>
              <span className={styles.RightSideFooterLinks}>
                <a target="__blank" href="https://app.nedvex.ru/about">
                  {t('containers.logIn.footer.about')}
                </a>
              </span>
            </div>
            <div>
              <span>{t('containers.logIn.footer.inn')}</span>
              <span>{t('containers.logIn.footer.ogrn')}</span>
              <span>
                {t('containers.logIn.footer.copyright', {
                  year,
                })}
              </span>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Login;



// WEBPACK FOOTER //
// ./src/containers/Login/Login2.js